import { ModelConfig } from '@bosmart/types';

/**
 * Gemini Model Configuration
 * 
 * Centralized configuration for model selection and voice settings.
 * Change these values to use different models or voices.
 */
export const geminiModelConfig: ModelConfig = {
  modelName: 'gemini-2.5-flash-native-audio-preview-09-2025',
  voiceConfig: {
    voiceName: 'Kore' // Natural, professional voice
  }
};

/**
 * Analysis Model Configuration
 * 
 * Model used for post-interview analysis and report generation.
 */
export const analysisModelConfig = {
  modelName: 'gemini-2.5-flash',
  responseMimeType: 'application/json' as const,
};

/**
 * Audio Processing Configuration
 * 
 * Sample rates and buffer settings for audio input/output.
 * Adjust these if you experience audio quality or latency issues.
 */
export const audioConfig = {
  inputSampleRate: 16000,   // Input audio sample rate (Hz)
  outputSampleRate: 24000,  // Output audio sample rate (Hz)
  bufferSize: 1024,         // Buffer size for audio processing (lower = less latency, improved responsiveness)
};
